export const SideNav = ({ groups, active, onSelect, footer, header, testidPrefix = "nav" }) => (
  <>
    {/* Desktop sidebar */}
    <aside className="hidden lg:flex flex-col w-64 shrink-0 border-r border-white/5 bg-[#08090D]/70 backdrop-blur-xl sticky top-0 h-screen overflow-y-auto" data-testid={`${testidPrefix}-sidebar`}>
      {header && <div className="px-5 pt-5 pb-4 border-b border-white/5">{header}</div>}
      <div className="flex-1 px-3 py-5 space-y-6">
        {groups.map(g => (
          <div key={g.label}>
            <div className="px-3 mb-2 font-mono text-[10px] uppercase tracking-widest text-[#475569]">{g.label}</div>
            <div className="space-y-0.5">
              {g.items.map(item => <NavBtn key={item.id} item={item} active={active === item.id} onSelect={onSelect} testid={`${testidPrefix}-${item.id}`} />)}
            </div>
          </div>
        ))}
      </div>
      {footer && <div className="px-3 pb-5">{footer}</div>}
    </aside>
    {/* Mobile strip */}
    <div className="lg:hidden flex gap-1.5 overflow-x-auto px-4 py-3 border-b border-white/5 bg-[#08090D]/80 backdrop-blur-xl sticky top-0 z-30">
      {groups.flatMap(g => g.items).map(item => (
        <button key={item.id} data-testid={`${testidPrefix}-m-${item.id}`} onClick={() => onSelect(item)}
          className={`shrink-0 flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium ${active === item.id ? "bg-[#8B5CF6]/20 text-white border border-[#8B5CF6]/40" : "text-[#94A3B8] border border-white/5"}`}>
          <item.icon className="w-3.5 h-3.5" /> {item.label}
        </button>
      ))}
    </div>
  </>
);

const NavBtn = ({ item, active, onSelect, testid }) => (
  <button
    data-testid={testid}
    data-tour={`nav-${item.id}`}
    onClick={() => onSelect(item)}
    className={`relative w-full flex items-center gap-3 px-3 py-2.5 text-sm font-medium group ${
      active ? "bg-gradient-to-r from-[#8B5CF6]/20 to-transparent text-white" : "text-[#94A3B8] hover:text-white hover:bg-white/[0.04]"
    }`}
  >
    {active && <span className="absolute left-0 top-2 bottom-2 w-[3px] rounded-full bg-[#8B5CF6] shadow-[0_0_12px_rgba(139,92,246,0.9)]" />}
    <item.icon className={`w-4 h-4 transition-colors ${active ? "text-[#A78BFA]" : item.color || "text-[#64748B] group-hover:text-[#CBD5E1]"}`} strokeWidth={2} />
    <span className="truncate">{item.label}</span>
    {item.badge && <span className="ml-auto text-[9px] font-bold px-1.5 py-0.5 rounded-md bg-[#F59E0B]/15 text-[#F59E0B]">{item.badge}</span>}
    {item.external && <span className="ml-auto text-[#94A3B8] text-xs group-hover:text-white">↗</span>}
  </button>
);
